<form *ngIf="form" class="validated-form" [formGroup]="form">

  <div *ngFor="let field of formDefinition.fields" class="grid">

    <div class="col-3">
      <label for="field.key">{{field.label}}</label>
    </div>

    <div class="col-9">

      <input *ngIf="field.type == 'text'" [name]="field.key" [placeholder]="field.placeholder" pInputText
        [id]="field.key" [formControlName]="field.key" class="dynamic-form-control" />
      <textarea *ngIf="field.type == 'multiline'" [name]="field.key" [placeholder]="field.placeholder" pInputText
        [id]="field.dataKey" [formControlName]="field.key" class="dynamic-form-control" rows="2"></textarea>

      <p-dropdown hideDropdownOnScroll *ngIf="field.type == 'dropdown'" [filter]="true" [id]="field.key"
        [name]="field.key" [(ngModel)]="field.value" [options]="field.options" [dataKey]="field.dataKey"
        [optionLabel]="field.optionLabel" [formControlName]="field.key" appendTo="body" class="dynamic-form-control">
      </p-dropdown>

      <p-dropdown hideDropdownOnScroll *ngIf="field.type == 'grouped-dropdown'" [group]="true" [filter]="true" [id]="field.key"
          [name]="field.key" [(ngModel)]="field.value" [options]="field.options" [dataKey]="field.dataKey"
          [optionLabel]="field.optionLabel" [formControlName]="field.key" appendTo="body" class="dynamic-form-control">
        <ng-template let-group pTemplate="group">
          <div><strong>{{group.label}}</strong></div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div style="margin-left:1em;">{{item.label}}</div>
        </ng-template>
      </p-dropdown>

      <ng-container *ngIf="field.type == 'debtor-account-history-widget-sequence-selection'">
        <debtor-account-history-widget-sequence-selection
          [formControlName]="field.key">
        </debtor-account-history-widget-sequence-selection>
      </ng-container>

      <mojo-query-builder *ngIf="field.type == 'queryBuilder'" [config]='field.options' [allowRuleset]="false"
        [query]="field.value" class="dynamic-form-control"></mojo-query-builder>

      <p-multiSelect hideMultiselectOnScroll *ngIf="field.type == 'multiSelect'" appendTo="body"
        [options]="field.options" [dataKey]="field.dataKey" [(ngModel)]="field.value" [optionLabel]="field.optionLabel"
        [formControlName]="field.key" defaultLabel="Choose" selectedItemsLabel="{0} items selected"></p-multiSelect>

      <p-table responsiveLayout="scroll" [value]="field.value" class="mojo-admin-page data-table"
        *ngIf="field.type == 'document-category'">
        <ng-template pTemplate="header">
          <tr>
            <th>Category</th>
            <th>
              Show?
              <div>
                <input type="checkbox" [checked]="documentCategoryShowAllChecked(field)"
                  (change)="handleDocumentCategoryShowAllChange($event, field)" />
              </div>
            </th>
            <th>
              Allow Upload?
              <div>
                <input type="checkbox" [checked]="documentCategoryAllowUploadAllChecked(field)"
                  (change)="handleDocumentCategoryAllowUploadAllChange($event, field)" />
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-category>
          <tr>
            <td>{{category.Name}}</td>
            <td>
              <input type="checkbox" name="categoryshow" [(ngModel)]="category.Show" [ngModelOptions]="{standalone: true}">
            </td>
            <td>
              <input type="checkbox" name="categoryallowupload" [(ngModel)]="category.AllowUpload" [ngModelOptions]="{standalone: true}">
            </td>
          </tr>
        </ng-template>
      </p-table>

      <ng-container *ngIf="field.type == 'checkbox'">
        <input
          type="checkbox"
          [id]="field.key"
          [name]="field.key"
          [formControlName]="field.key"
          [(ngModel)]="field.value"
          [ngModelOptions]="{standalone: true}"
          [binary]="true"
          style="margin-right:0.2em;">
        <span>{{field.optionLabel}}</span>
      </ng-container>

      <ng-container *ngIf="field.type == 'documents-for-related-records-filter'">
        <div>
          <input
            type="checkbox"
            [id]="field.key + '-include-parents'"
            [name]="field.key + '-include-parents'"
            [(ngModel)]="field.value.IncludeParents"
            [ngModelOptions]="{standalone: true}"
            [binary]="true"
            style="margin-right:0.2em;">
          <span>Parent records</span>
        </div>
        <div>
          <input
            type="checkbox"
            [id]="field.key + '-include-children'"
            [name]="field.key + '-include-children'"
            [(ngModel)]="field.value.IncludeChildren"
            [ngModelOptions]="{standalone: true}"
            [binary]="true"
            style="margin-right:0.2em;">
          <span>Child records</span>
        </div>
      </ng-container>

      <mojo-additional-information-admin-form [formControlName]="field.key"
        *ngIf="field.type == 'additional-info-selector'"></mojo-additional-information-admin-form>

      <quill-editor theme="bubble"
        [modules]="field.options?.modules"
        [required]="field.options?.required"
        [minlength]="field.options?.minlength"
        [maxLength]="field.options?.maxlength"
        [placeholder]="field.placeholder"
        [trimOnValidation]="true"
        format="html"
        [formControl]="form.get(field.key)"
        *ngIf="field.type == 'minimal-html-editor'">
      </quill-editor>

      <mojo-validation-messages [formField]="form.controls[field.key]" [definition]="field"></mojo-validation-messages>
    </div>
  </div>

  <ng-content select="[custom-form-content]"></ng-content>

  <div class="ui-dialog-buttonpane dynamic-form-buttons ui-helper-clearfix">
    <button *ngIf="displayDeleteButton" id="delete-button" type="button" pButton icon="fa-fw fa fa-trash-o"
      (click)="delete()" label="Delete"></button>
    <button *ngIf="displayResetAllUsersButton" id="resetusers-button" type="button"
            pButton icon="fa-fw fa fa-refresh" (click)="resetAllUsersToDefaultColumns()"
            label="Reset for All Users"></button>
    <button *ngIf="displayCreateCopyButton" id="createcopy-button" type="button"
      [disabled]="!form.valid || form.pristine" pButton icon="fa-fw fa fa-copy" (click)="createCopy()"
      label="Create Copy"></button>
    <button *ngIf="displaySaveButton" id="save-button" type="button" [disabled]="!form.valid" pButton
      icon="fa-fw fa fa-check" (click)="submit()" label="Save"></button>
    <button *ngIf="displayCancelButton" id="cancel-button" type="button" pButton icon="fa-fw fa fa-close"
      (click)="cancel()" label="Cancel"></button>
    <ng-content select="[custom-form-buttons]"></ng-content>
  </div>

</form>
